import { render, staticRenderFns } from "./tableProducts.vue?vue&type=template&id=39a6fdc6"
import script from "./tableProducts.vue?vue&type=script&lang=js"
export * from "./tableProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports